"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeNoDataRGB;
function makeNoDataRGB(noDataValue) {
  // typescript not smart enough to realize all values in the array will be the same
  // @ts-ignore
  return [noDataValue, noDataValue, noDataValue];
}